import React from "react";
import PropTypes from "prop-types";

const PageTitle = ({ title, subtitle, className, ...attrs }) => {

  return (
    <div style={{width: '100%'}} { ...attrs }>
      <span className="text-uppercase page-subtitle">{subtitle}</span>
      <h3 className="page-title">{title}</h3>
    </div>
  )
};

PageTitle.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string
};

export default PageTitle;
